import { Swiper, SwiperSlide } from "swiper/react";
import styles from "./CarSlider.module.scss";
import classNames from "classnames/bind";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/effect-fade";

import { Pagination, EffectFade } from "swiper";
import { faAngleRight, faImage } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
const cx = classNames.bind(styles);
function CarSlider() {
    const banner = [
        {
            link: "https://i.ibb.co/ByQbM6v/urus.webp",
        },
        {
            link: "https://autopro8.mediacdn.vn/2021/12/24/lamborghini-urus-by-mansory-and-mtm-1-16403302346402004678443.jpg",
        },
        {
            link: "https://autopro8.mediacdn.vn/2021/12/24/lamborghini-urus-by-mansory-and-mtm-5-164033023452676139688.jpg",
        },
    ];

    return (
        <>
            <Swiper
                slidesPerView={1}
                effect={"fade"}
                loop
                autoplay={{
                    delay: 5000,
                    disableOnInteraction: true,
                }}
                grid={{
                    rows: 1,
                }}
                pagination={{
                    dynamicBullets: true,
                }}
                modules={[Pagination, EffectFade]}
                breakpoints={{
                    "@0.00": {
                        slidesPerView: 1,
                    },
                    "@1.25": {
                        slidesPerView: 1,
                    },
                }}
                className={cx("swiper")}
            >
                <div className={cx("img_count")}>
                    <FontAwesomeIcon icon={faImage} />
                    <span>3</span>
                    <FontAwesomeIcon icon={faAngleRight} />
                </div>
                {banner.map((item, index) => (
                    <SwiperSlide key={index} className={cx("swiper_item")}>
                        <img
                            className={cx("swiper-lazy")}
                            src={item.link}
                            alt={item.alt}
                        />
                    </SwiperSlide>
                ))}
            </Swiper>
        </>
    );
}
export default CarSlider;
